export enum MemoryCache {
  //消金memory cache
  //消金通用下拉選單
  RETAIL_DROPDOWN_CACHE_KEY = 'retailDropdownOptions',
  //消金角色代碼對應
  RETAIL_ROLE_CODE_CACHE_KEY = 'retailRoleCode',
  //底下為車輛目前有使用的memory cache 但考量車輛元件後續會持續更新因此不調整成使用此enum
  //幣別匯率 CurrencyExchangeService
  CURRENCY_EXCHANGE_RATE_CACHE_KEY = 'currencyExchangeRates',
  //部門名稱 DepartmentNameService
  DEPARTMENT_NAME_INFO_CACHE_KEY = 'departmentNameInfo',
  //通用下拉選單 DropdownOptionsService
  COMMON_DROPDOWN_CACHE_KEY = 'commonDropdownOptions',
  //郵遞區號 DropdownOptionsService
  POSTCODE_LIST_CACHE_KEY = 'postcodeList',
  //登入者資訊 UserComposerService
  USER_INFO_CACHE_KEY = 'userInfo',
}
